export default __webpack_public_path__ + "static/media/NoRacesMascot.184be590.png";